import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { User } from 'src/app/models/user.model';
import { ProfileVideo } from 'src/app/models/profile-video.model';
import { UsersService } from 'src/app/services/users.service';
import { TimezoneService } from 'src/app/services/timezone.service';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'sa-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss']
})
export class UserInfoComponent implements OnInit, OnDestroy {

  @Input()
  user: User;
  options: google.maps.MapOptions;
  marker: google.maps.MarkerOptions;

  public timezoneAbbr: string = 'PST';
  private timezoneSubscription: Subscription | null = null;

  /**
   * Every video on the profile, slot order.
   *
   * The list endpoints only carry READY videos, because a table shows what the
   * deck shows. This page is where an admin asks why a profile is not being
   * shown, so it refetches the user and keeps every status — a video stuck in
   * `processing` or turned away by moderation is the answer to that question.
   */
  public videos: ProfileVideo[] = [];

  constructor(
    public usersService: UsersService,
    public timezoneService: TimezoneService
  ) {}

  get displayName(): string {
    return `${this.user.name || ''} ${this.user.lastname || ''}`.trim()
      || `#${this.user.user_id}`;
  }

  ngOnInit(): void {
    // Render whatever the row already carried, then upgrade to the full set.
    this.videos = this.user.profile_videos || [];
    this.usersService.getUser(this.user.user_id).subscribe({
      next: (fetched) => {
        if (fetched && fetched.profile_videos) {
          this.videos = fetched.profile_videos;
        }
      },
      // A failed refetch leaves the ready videos from the row on screen, which
      // is still a working page — never blank the strip over it.
      error: () => {},
    });

    if (this.user.last_location?.coordinates) {
      this.options = {
        center: {
          lat: +this.user.last_location.coordinates[1],
          lng: +this.user.last_location.coordinates[0],
        },
        zoom: 5,
      };
      this.marker = {
        position: {
          lat: +this.user.last_location.coordinates[1],
          lng: +this.user.last_location.coordinates[0],
        },
      };
    }
    this.timezoneAbbr = this.timezoneService.getCurrentTimezoneAbbr();
    this.timezoneSubscription = this.timezoneService.getTimezoneConfig().subscribe(() => {
      this.timezoneAbbr = this.timezoneService.getCurrentTimezoneAbbr();
    });
  }

  notesValueChanged(newValue) {
    this.user.admin_notes = newValue;
    this.usersService.updateUser(this.user.user_id, {
      admin_notes: newValue,
    }).subscribe();
  }

  ngOnDestroy() {
    if (this.timezoneSubscription) {
      this.timezoneSubscription.unsubscribe();
    }
  }
}
